module.exports = __webpack_public_path__ + "img/Rwanda.f6b6d25a.svg";